import { Contract } from "near-api-js";
import { useEffect, useState } from "react";
import useNear from "./nearHook";

const ENUMERATE_PAGE_SIZE = 10;

const useSbtPermissions = () => {
  const near = useNear();

  const getContract = async (contractId) => {
    // debugger;
    const contract = await new Contract(
      near.account.wallet.account(),
      contractId,
      {
        viewMethods: [
          "sbt_permissions",
          "sbt_permissions_count",
          "sbt_permissions_metadata",
        ],
        changeMethods: ["create_permission"],
      }
    );
    return contract;
  };

  const getContractMetadata = async (contractId) => {
    try {
      const contract = await getContract(contractId);
      return await contract.sbt_permissions_metadata();
    } catch {
      return null;
    }
  };

  const getSbtPermissionsForToken = async (contractId, tokenLocator) => {
    try {
      const contract = await getContract(contractId);
      const supply = await contract.sbt_permissions_count({
        token: tokenLocator,
      });

      const res = await Promise.all(
        [...Array(Math.ceil(supply / ENUMERATE_PAGE_SIZE)).keys()].map((i) =>
          contract.sbt_permissions({
            token: tokenLocator,
            from_index: i * ENUMERATE_PAGE_SIZE,
            limit: Math.min((i + 1) * ENUMERATE_PAGE_SIZE, supply),
          })
        )
      );
      return res.flat();
    } catch {
      return [];
    }
  };

  const createTokenLocator = (contractId, tokenId) => {
    return {
      chain_id: "near",
      sbt_contract_id: contractId,
      token_id: tokenId,
    };
  };

  const addConsent = async (contractId, tokenIds, publicKey, signature) => {
    const tokens = tokenIds.join(",");
    const sig = await near.account.sign(tokens);

    const contract = await getContract(contractId);

    return await contract.add_consent({
      consent: {
        signed_ids: tokenIds,
        public_key: sig.public_key,
        signature: sig.signature,
      },
    });
  };

  const grantPermissions = async (contractId, tokenLocators, accounts) => {
    console.log(tokenLocators, accounts);
    const body = {
      sbt_tokens: tokenLocators,
      accounts: accounts,
    };
    const bodyToSign = JSON.stringify(body);
    console.log(bodyToSign);
    const sig = await near.account.sign(bodyToSign);

    const contract = await getContract(contractId);

    return await contract.create_permission({
      permission: {
        body: body,
        signature: sig.signature,
        public_key: sig.public_key,
      },
    });
  };

  return {
    getContractMetadata,
    getSbtPermissionsForToken,
    createTokenLocator,
    grantPermissions,
  };
};

export default useSbtPermissions;
